import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-district',
  templateUrl: './top-district.component.html',
  styleUrls: ['./top-district.component.scss']
})
export class TopDistrictComponent implements OnInit {

  constructor() { }

  @Input() topDistrict:any = [];
  @Input() currencySymbol:any;

  ngOnInit(): void {
  }

}
